import { UpsellResultEnum } from '@tiendanube/nexo';
import { FEATURE_ORDERS_AUTO_CANCEL } from 'App/features';
import { useUpsellFlow } from 'domains/Billing/UpsellFlow/hooks';
import { trackingOrderListAutoCancelButtonClick } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface UseOrdersAutoCancelUpsellProps {
  callback: () => void;
  nuvemPagoIsActive?: boolean;
}

export function useOrdersAutoCancelUpsell({
  callback,
  nuvemPagoIsActive = false,
}: Readonly<UseOrdersAutoCancelUpsellProps>) {
  const t = useTranslationOrders('autoCancel');

  return useUpsellFlow({
    title: t('upsellTitle'),
    featureKey: FEATURE_ORDERS_AUTO_CANCEL,
    includeCallbackResult: true,
    callback: (upsellResult: UpsellResultEnum) => {
      if (
        upsellResult === UpsellResultEnum.SKIPPED ||
        upsellResult === UpsellResultEnum.ACCEPTED
      ) {
        callback();
      }
    },
    onCloseModal: (upsellResult) => {
      if (upsellResult === UpsellResultEnum.DECLINED) {
        // Track that user declined the upsell for auto cancel
        trackingOrderListAutoCancelButtonClick(nuvemPagoIsActive);
      }
    },
  });
}
